export default __webpack_public_path__ + "static/media/L.6b2d0d44.png";